
import { Notification } from 'element-ui';




/**
 * 混合了消息弹出框的函数
 */

function iNotify (title,type,msg) {
    Notification({
      title: title,
      message: msg,
      type: type
    });
};



const sCallBack = (res) => {

    if(res&&res.solely_code == '100000'){
      iNotify(res.msg,'success');
      return 'success';
    }else{
      iNotify(res.msg,'error');
      return false;
    };

};



const notify = (title,type,msg) => {

    Notification({
      title: title,
      message: msg,
      type: type?type:'success'
    });

};



const cloneForm = (form) => {

    var res =  JSON.parse(JSON.stringify(form));
    return res;

};



const imgchange = (self,data,formName,attrName) => {


        data.forEach((item, index) => {

          if(item['response']){
          item['url'] = item['response'];
          };
          delete item['percentage'];
          delete item['raw'];
          delete item['size'];
          delete item['status'];
          delete item['response'];
          delete item['uid'];

        });


        if(data.length){
        self[formName][attrName] = data;
        }else{
        self[formName][attrName] = 'empty';
        };

};



const resetForm = (formName) => {
  self.$refs[formName].resetFields();
  console.log('restform');
  if(formName == 'searchform'){
    self[formName] = {};
  }
};



function padLeftZero (str) {
    return ('00' + str).substr(str.length);
};



const formatDate =  (date, fmt) =>{

    if(!date||date=='undefined'||date=='null'||date=="Invalid Date"){
      return;
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};



const getParentNames = (array,id,childName,results) => {

  if(!childName){
    var childName = 'children';
  };

  if(!results){
    var results = [id];
  };
  var pid = '';
  getParentId(array,id);

  if(pid){
    results.push(pid);

    if(pid>0){
      getParentNames(array,pid,childName,results);
    }
  };
  return results;

    function getParentId(array,id){

    for(var i=0;i<array.length;i++){
      if(pid>0){
        return false;
      };
      var item=array[i];
      if(item.id==id){
        pid = item.parentid;
        return false;
      }else if(item[childName]&&item[childName].length>0){
        getParentId(item[childName],id);
      };
    };
  };
};



const getArrayByTarget = (array,targetName,target,childName) => {

  var results = [];
  if(!childName){
    var childName = 'children'
  };

  getItemsBytarget(array,targetName,target,childName);

  return results;
  function getItemsBytarget(array,targetName,target,childName){

    for(var i = 0;i < array.length; i++){
      if(results.length>0){
        return false;
      }
      var item = array[i];
      if(item[targetName] == target){
        results.push(item);
      }else if(item[childName]&&item[childName].length>0){
        getItemsBytarget(item[childName],targetName,target);
      }
    };

  };

};



const getArrayByTargetTwo = (array,targetName,target) => {

  var results = [];
  getItemsBytarget(array,targetName,target);
  return results;
  function getItemsBytarget(array,targetName,target){

    for(var i = 0;i < array.length; i++){
      if(results.length>0){
        return false;
      }
      var item = array[i];
      if(item[targetName] == target){
        results.push(item);
      }else if(item.children&&item.children.length>0){
        getItemsBytarget(item.children,targetName,target);
      }
    };

  };

};



const isArrayFn = (value)=>{

  if (typeof Array.isArray === "function") {
    return Array.isArray(value);
  }else{
    return Object.prototype.toString.call(value) === "[object Array]";
  }

};



const isTest = (value)=>{

  return value

};



const getChildNames = (array,key,childName,id,results) => {

  if(!childName){
    var childName = 'children';
  };

  if(!results){
    var results = [];
  };
  var child_array = [];
  getChildrenArray(array,key);

  if(child_array.length>0){
    getChildId(child_array,key)
  };

  return results;

  function getChildrenArray(array,key){
    for(var i=0;i<array.length;i++){
      if(array[i][key]==id){
        if(array[i][childName]&&array[i][childName].length>0){
          child_array = array[i][childName];
        }
      }else if(array[i][childName]&&array[i][childName].length>0){
        getChildrenArray(array[i][childName],key);
      };
    };
  };

  function getChildId(child_array,key){
    for(var i=0;i<child_array.length;i++){
      results.push(child_array[i][key]);
      if(child_array[i][childName]&&child_array[i][childName].length>0){
        getChildId(child_array[i][childName],key);
      };
    };
  };
};



export default {
  isArrayFn,
  getArrayByTarget,
  isTest,
  cloneForm,
  imgchange,
  resetForm,
  formatDate,
  getParentNames,
  sCallBack,
  notify,
  formatDate,
  getArrayByTargetTwo,
  getChildNames,
}



// WEBPACK FOOTER //
// ./src/utils/func/func.js